import type { TGalleryItem } from '../../types/galleryItem';

export const loadImageAsync = (galleryItem: TGalleryItem): Promise<TGalleryItem | null> => {
  return new Promise((resolve) => {
    const image = new Image();

    image.src = galleryItem.imageUrl;

    image.onload = () => resolve(galleryItem);
    image.onerror = () => resolve(null);
  });
};
